import { Route } from "react-router-dom";
import ReservationsBookingsbyLocationReportScreen from "../../../container/Reservations/ReservationsBookingsbyLocationReportScreen";
import CreateReservationsBookingsbyLocationReport from "../../../container/Reservations/ReservationsBookingsbyLocationReportScreen/CreateReservationsBookingsbyLocationReport";
import { APP_URLS } from "../../../utils/constant";

const ReservationsBookingsbyLocationReportRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_BOOKINGBYLOCATIONREPORT.HOME}
          element={
            <ReservationsBookingsbyLocationReportScreen
              screenPermissions={access}
            />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RESERVATIONS_BOOKINGBYLOCATIONREPORT.CREATE}
          element={<CreateReservationsBookingsbyLocationReport />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RESERVATIONS_BOOKINGBYLOCATIONREPORT.EDIT}
          element={<CreateReservationsBookingsbyLocationReport isEdit={true} />}
        />
      )}
    </>
  );
};

export default ReservationsBookingsbyLocationReportRoutes;
